import React from 'react';

import SplitConverter from '../SplitConverter/SplitConverter';
import {converterSources} from '../converterTargets';

export default function Converter() {
    return (
        <SplitConverter sources={converterSources}/>
    );
}
